import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/landing-app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/landing-app/src/assets/games/rush-mid-hero.webp");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsInitializer"] */ "/app/apps/landing-app/src/components/AnalyticsInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageHydrator"] */ "/app/apps/landing-app/src/components/LanguageHydrator.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/landing-app/src/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["RuntimeProvider"] */ "/app/apps/landing-app/src/runtime/RuntimeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/landing-app/src/runtime/tma/TmaAppMount.tsx");
